import { render, staticRenderFns } from "./HistoryTransaction.vue?vue&type=template&id=38ae7090"
import script from "./HistoryTransaction.vue?vue&type=script&lang=js"
export * from "./HistoryTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports